import React, { useState } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import NoSleep from "nosleep.js"

const ZodiacSelectionFB = () => {
  const {
    setSelectedSign,
    setBackgroundAudio,
    setMainAudio,
    setCurrentStep,
    setAudioEnded,
    setCurrentAudioStage,
    setCurrentAudioTime,
    setNoSleep,
    setButtonClickAudio,
    setExitIntent,
    exitIntent,
  } = useSiteContext()

  const signs = [
    {
      name: "Aries",
    },
    {
      name: "Taurus",
    },
    {
      name: "Gemini",
    },
    {
      name: "Cancer",
    },
    {
      name: "Leo",
    },
    {
      name: "Virgo",
    },
    {
      name: "Libra",
    },
    {
      name: "Scorpio",
    },
    {
      name: "Sagittarius",
    },
    {
      name: "Capricorn",
    },
    {
      name: "Aquarius",
    },
    {
      name: "Pisces",
    },
  ]
  // const imageData = useStaticQuery(graphql`
  //   {
  //     allFile(
  //       filter: { relativeDirectory: { eq: "signs-small" } }
  //       sort: { name: ASC }
  //     ) {
  //       edges {
  //         node {
  //           childImageSharp {
  //             gatsbyImageData(placeholder: BLURRED, quality: 95)
  //           }
  //           name
  //         }
  //       }
  //     }
  //   }
  // `)

  const [disappearing, setDisappearing] = useState(false)

  const handleClick = name => {
    setSelectedSign(name)
    setDisappearing(true)

    let temp1 = new Audio("/audio/bg-music.mp3")
    let temp3 = new Audio("/audio/bg-music.mp3")
    // temp1.loop = true;
    temp1.addEventListener("timeupdate", function () {
      const buffer = 1.1
      if (this.currentTime > this.duration - buffer) {
        temp3.play()
      }
    })
    temp3.addEventListener("timeupdate", function () {
      const buffer = 1.1
      if (this.currentTime > this.duration - buffer) {
        temp1.play()
      }
    })
    // setBackgroundAudio(temp1)
    temp1.play()

    let temp2 = new Audio(`/audio/welcome-${name.toLowerCase()}.mp3`)
    temp2.addEventListener("ended", () => setAudioEnded(true))
    temp2.addEventListener("timeupdate", () =>
      setCurrentAudioTime(temp2.currentTime)
    )
    setMainAudio(temp2)
    setCurrentAudioStage("welcome")

    setTimeout(() => {
      setCurrentStep(2)
    }, 700)

    setTimeout(() => temp2.play(), 1500)

    let tempButtonClick = new Audio("/audio/button-click.mp3")
    setButtonClickAudio(tempButtonClick)

    const noSleepObject = new NoSleep()
    noSleepObject.enable()
    setNoSleep(noSleepObject)

    document.addEventListener("mouseout", event => {
      if (!event.relatedTarget && !event.toElement) {
        setExitIntent(true)
      }
    })

    // Store click ID for astroveo (if sent from their FB campaign)
    if (
      window.location.search.includes("affiliate=astroveo") &&
      window.location.search.includes("tid=Facebook")
    ) {
      const clickID = window.tokens?.bcid
      localStorage.setItem("astroveo_ClickID", clickID)
    }

    // Store click ID for MGID
    if (window.location.search.includes("click_id=")) {
      const params = new URL(document.location).searchParams
      const clickID = params.get("click_id")
      localStorage.setItem("mgidClickID", clickID)
    }

    window.onbeforeunload = function (event) {
      event.preventDefault()
      event.returnValue = true
    }
  }

  return (
    <>
      <div
        className={`${
          disappearing ? "disappear transition duration-1000" : ""
        } text-center`}
      >
        <h1 className="text-2xl font-bold text-white md:text-4xl">
          Click Your Sign To Begin...
        </h1>
        {/* <h2 className="mt-4 text-lg text-white md:text-2xl">
          Your Luck Is About To Change...
          <br />
          Click Your Sign To Begin.
        </h2> */}
      </div>
      <div
        className={`grid grid-cols-4 gap-2 mt-6 sm:gap-4 ${
          disappearing ? "disappear transition duration-1000" : ""
        }`}
      >
        {signs.map((sign, i) => {
          return (
            <button
              onClick={() => handleClick(sign.name)}
              type="button"
              disabled={disappearing}
              key={i}
              className="flex flex-col items-center text-white transition duration-300 ease-in-out rounded-lg cover-glow hover:text-brand-pink hover:scale-110"
            >
              <div
                className={`w-[75px] sm:w-[120px] h-[75px] sm:h-[120px] ${sign.name.toLowerCase()} zodiac-pulse`}
              ></div>
              <p className="text-sm font-bold text-center underline md:text-base">
                {sign.name}
              </p>
            </button>
          )
        })}
      </div>
      {/* <p
        className={`${
          disappearing ? "disappear transition duration-1000" : ""
        } py-2 mt-6 text-sm md:text-base font-semibold text-center text-white bg-black bg-opacity-50`}
      >
        Over <span className="text-brand-gold">1,111 lives changed,</span> and
        counting!
        <br />
        Will you be next?
      </p> */}
    </>
  )
}

export default ZodiacSelectionFB
